import React from "react";
import { One  } from "./Chart.config";
import ShreeDayTable from "./ShreeDayTable";

const ShreeDay = ({ chartData }) => {
  return <ShreeDayTable staticData={One} chartData={chartData} />;
};

export default ShreeDay;
